module.exports = __webpack_public_path__ + "static/img/2.62f5e53.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/1/17/zh/2.png
// module id = 7GGT
// module chunks = 0